var Config = {
    DEBUG: false,
    LIB_VERSION: '2.68.0'
};

export default Config;
